/*
 * @Author: wangshengqiang
 * @Date: 2022-02-26 15:07:02
 * @LastEditTime: 2022-02-26 16:29:27
 * @LastEditors: wangshengqiang
 * @Description: 
 */
import React from 'react';
import EventBtn from '@/components/EventBtn';
import './index.less';
const BtnGroup = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs: {
      dataSource = [],
      isfixed = true
    },
    form
  } = props;
  const _style = {
    position: isfixed ? 'fixed' : 'static'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "components-btn-group-render",
    style: _style
  }, dataSource.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: item.id || index,
    className: "btn-item"
  }, /*#__PURE__*/React.createElement(EventBtn, {
    form: form,
    events: item.events,
    buttonText: item.label
  }))));
});
export default BtnGroup;